module.exports = __webpack_public_path__ + "static/media/zoomsprt.ea23482a.png";